export default class Character {
    constructor() {
        this.conts = [...document.querySelectorAll('.js-character_cont')];
        this.sides = [...document.querySelectorAll('.js-character_side')];

        this.currentId = 1;

        this.init();
    }

    init() {
        this.eventBind();
    }

    eventBind() {
        const prevs = [...document.querySelectorAll('.js-character_prev')];
        const nexts = [...document.querySelectorAll('.js-character_next')];

        for (const prev of prevs) {
            prev.addEventListener('click', () => {
                this.currentId = 1 >= this.currentId ? this.conts.length : this.currentId - 1;
                this.changeCharacter();
            });
        }

        for (const next of nexts) {
            next.addEventListener('click', () => {
                this.currentId = this.currentId >= this.conts.length ? 1 : this.currentId + 1;
                this.changeCharacter();
            });
        }

        for (const side of this.sides) {
            side.addEventListener('click', () => {
                this.currentId = parseInt(side.dataset.id);
                this.changeCharacter();
            });
        }
    }

    changeCharacter() {
        const elsList = ['conts', 'sides'];

        for (const els of elsList) {
            for (const el of this[els]) {
                const id = parseInt(el.dataset.id);
                const method = this.currentId == id ? 'add' : 'remove';
                el.classList[method]('-active');
            }
        }
    }
}
